import cn from 'classnames'
import styles from './styles.module.css'
import SeasonCheckbox from '../season-checkbox'

const SeasonCheckboxGroup = ({
    onUpdated,
    label,
    values = [],
    handleChange,
    className,
    labelClassName,
    tagsClassName,
    checkboxClassName,
    schoolsList
}) => {
    return <div className={cn(styles.checkboxGroup, className)}>
        {label && <div className={cn(styles.label, labelClassName)}>
            {label}
        </div>}

        <div className={cn(styles.checkboxGroupItems, tagsClassName)}>
            {values.map(item => {
                return <SeasonCheckbox
                    key={item.id}
                    id={item.id}
                    value={item.value}
                    name={item.season_number}
                    color={item.color}
                    onChange={handleChange}
                    className={checkboxClassName}
                    count = {schoolsList.results?.filter((school)=>school.season.season_number===item.season_number).lenght}
                />
            })}
        </div>
    </div>
}

export default SeasonCheckboxGroup